import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Unverified',
      type: 'metric',
      content: {
        '{}': {
          name: 'Unverified',
          value: {
            '{}': {
              quality: 'neutral',
              tooltip:
                'Approved requirement with a linked implementation pull request, but no test results have been recorded yet.',
              emphasis: {
                'fmt.num': [
                  {
                    '#': {
                      '@': 'unverifiedRequirements',
                    },
                  },
                  {
                    ',': true,
                    '.': {
                      always: 0,
                    },
                  },
                ],
              },
            },
          },
          description: 'Requirements built but not yet tested.',
        },
      },
    },
  },
  subqueries: {
    unverifiedRequirements: {
      filter: {
        and: [
          {
            or: [
              { '=': [{ '@$': 'projectId' }, null] },
              {
                '=': [
                  { '@': 'specProject' },
                  { '@>': [{ '@$': 'projectId' }, 'recordId'] },
                ],
              },
            ],
          },
          {
            '!=': [
              {
                '@': 'specApprovedAt',
              },
              null,
            ],
          },
          {
            '!=': [
              {
                '@': 'buildLinks',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@': 'failingLinks',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@': 'passingLinks',
              },
              null,
            ],
          },
        ],
      },
      target: 'ent:!requirements:!requirement',
      selection: {
        '@.': '!id',
      },
      subqueries: {
        specProject: {
          ref: { attr: 'attr:ent#!requirements#!requirement:!spec' },
          target: 'ent:!specs:!spec',
          selection: { '@.': ['!project', { ref: { entity: '!proj' } }] },
        },
        specApprovedAt: {
          ref: {
            attr: 'attr:ent#!requirements#!requirement:!spec',
          },
          target: 'ent:!specs:!spec',
          quantity: 1,
          selection: {
            '@': 'approvalMergedAt',
          },
          subqueries: {
            approvalMergedAt: {
              ref: {
                attr: 'attr:ent#!specs#!spec:!approval_pull_request',
              },
              target: 'ent:!pull_requests:!pull_request',
              selection: {
                '@.': '!merged_at',
              },
            },
          },
        },
        buildLinks: {
          ref: {
            attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
          },
          target: 'ent:!pr_req_links:!pr_req_link',
          selection: {
            '@.': '!id',
          },
        },
        failingLinks: {
          ref: {
            attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
          },
          target: 'ent:!pr_req_links:!pr_req_link',
          filter: {
            '=': [
              {
                '@': 'testOutcome',
              },
              'FAIL',
            ],
          },
          selection: {
            '@.': '!id',
          },
          subqueries: {
            testOutcome: {
              ref: {
                attr: 'attr:ent#!pr_req_links#!pr_req_link:!pull_request',
              },
              target: 'ent:!pull_requests:!pull_request',
              selection: {
                '@': 'result',
              },
              subqueries: {
                result: {
                  ref: {
                    attr: 'attr:ent#!results#!result:!pull_request',
                  },
                  target: 'ent:!results:!result',
                  quantity: 1,
                  selection: {
                    '@.': '!test_outcome',
                  },
                },
              },
            },
          },
        },
        passingLinks: {
          ref: {
            attr: 'attr:ent#!pr_req_links#!pr_req_link:!requirement',
          },
          target: 'ent:!pr_req_links:!pr_req_link',
          filter: {
            '=': [
              {
                '@': 'testOutcome',
              },
              'PASS',
            ],
          },
          selection: {
            '@.': '!id',
          },
          subqueries: {
            testOutcome: {
              ref: {
                attr: 'attr:ent#!pr_req_links#!pr_req_link:!pull_request',
              },
              target: 'ent:!pull_requests:!pull_request',
              selection: {
                '@': 'result',
              },
              subqueries: {
                result: {
                  ref: {
                    attr: 'attr:ent#!results#!result:!pull_request',
                  },
                  target: 'ent:!results:!result',
                  quantity: 1,
                  selection: {
                    '@.': '!test_outcome',
                  },
                },
              },
            },
          },
        },
      },
    },
  },
}
